import { makeBetterEnum } from './betterEnum';

export const WATERSHED_DOMAIN = 'watershedclimate.com';
export const WATERSHED_EMAIL_SUFFIX = `@${WATERSHED_DOMAIN}`;
export const WATERSHED_CONTRACTOR_EMAIL_SUFFIX = `-c${WATERSHED_EMAIL_SUFFIX}`;

// These orgs are the contractor equivalent of the Watershed Root org and are used to give contractors initial access to Watershed
export const CONTRACTOR_MANAGEMENT_ORG_IDS = [
  'org_2BM4xnwCjzuGuoEKHdzB', // Accenture CDAs
  'org_2EW4xi6xAaEQAr9Uu1Ss', // KPMG CDAs
];

export const LockedReason = makeBetterEnum('deletion', 'migration');

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type LockedReason = (typeof LockedReason)[keyof typeof LockedReason];
